import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css'
import it from 'vuetify/es5/locale/it'
import { Ripple } from 'vuetify/lib/directives'



Vue.use(Vuetify, {
	directives: {
		Ripple
	},
})

export default new Vuetify({
	icons: {
		iconfont: 'md',
	},	
	lang: {
		locales: { it },
		current: 'it'
	},
	theme: {
		themes: {
			light: {
				primary: '#FFC107',
				secondary: '#424242',
				accent: '#FFE57F',
				error: '#FF5252',
				info: '#2196F3',
				success: '#4CAF50',
				warning: '#FF6D00',
				'background-1': '#F5F5F5',
				'background-2': '#FFFFFF',
				'background-3': '#CFCFCF',
				'background-4': '#FAFAFA',
			},
			dark: {
				primary: '#FFC107',
				secondary: '#424242',
				accent: '#FFE57F',
				error: '#FF5252',
				info: '#2196F3',
				success: '#4CAF50',
				warning: '#FF6D00',
				'background-1': '#303030',
				'background-2': '#424242',
				'background-3': '#757575',
				'background-4': '#212121',
			},
		}
	}
})
